
export const updateDocumentTitle = (title: string) => {
  document.title = title;
};

export const updateMetaDescription = (description: string) => {
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    document.head.appendChild(metaDescription);
  }
  metaDescription.setAttribute('content', description);
};

export const updateCanonicalUrl = (path: string) => {
  let canonicalLink = document.querySelector('link[rel="canonical"]');
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    document.head.appendChild(canonicalLink);
  }
  // Normalize the path: remove trailing slashes and ensure proper formatting
  const normalizedPath = path === '/' ? '' : path.replace(/\/+$/, '');
  const canonicalUrl = `https://www.carolinatrophyroofs.com${normalizedPath}`;
  canonicalLink.setAttribute('href', canonicalUrl);
  
  // Also add alternate link for www and non-www versions
  let alternateLink = document.querySelector('link[rel="alternate"][hreflang="x-default"]');
  if (!alternateLink) {
    alternateLink = document.createElement('link');
    alternateLink.setAttribute('rel', 'alternate');
    alternateLink.setAttribute('hreflang', 'x-default');
    document.head.appendChild(alternateLink);
  }
  alternateLink.setAttribute('href', canonicalUrl);
};

export const updateRobotsTag = (path: string) => {
  let robotsTag = document.querySelector('meta[name="robots"]');
  if (!robotsTag) {
    robotsTag = document.createElement('meta');
    robotsTag.setAttribute('name', 'robots');
    document.head.appendChild(robotsTag);
  }
  
  // CRITICAL: Only noindex admin pages, 404, auth, and post-preview
  // Everything else should be indexable by Google
  const shouldNoIndex = 
    path.includes('Blog-Page-Builder') || 
    path.includes('/admin') || 
    path.includes('/auth') ||
    path.includes('/post-preview') ||
    path.includes('/seo-audit') ||
    path.includes('/variables') ||
    path.includes('/templates') ||
    path.includes('/create-post') ||
    path.includes('/posts') ||
    path.includes('/photo-album') ||
    path === '/404';
  
  if (shouldNoIndex) {
    robotsTag.setAttribute('content', 'noindex, nofollow');
  } else {
    // Allow full indexing for all public pages
    robotsTag.setAttribute('content', 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1');
  }
};

export const removeExistingSchema = () => {
  // Remove ALL existing schema scripts to prevent conflicts
  const existingSchemas = document.querySelectorAll('script[type="application/ld+json"]');
  existingSchemas.forEach(schema => schema.remove());
};

export const addSchemaToHead = (schema: object) => {
  const schemaScript = document.createElement('script');
  schemaScript.setAttribute('type', 'application/ld+json');
  schemaScript.textContent = JSON.stringify(schema);
  document.head.appendChild(schemaScript);
};
